// src/utils/helpers.ts

import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind classes with conflict resolution
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Detect browser language
 */
export function detectLanguage(): string {
  if (typeof window === 'undefined') return 'en'

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const browserLang = navigator.language || (navigator as any).userLanguage
  const lang = browserLang.split('-')[0].toLowerCase()

  // Supported languages
  const supported = ['en', 'cs', 'de']
  return supported.includes(lang) ? lang : 'en'
}

/**
 * Log debug message
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debugLog(message: string, ...args: any[]) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (typeof window !== 'undefined' && (window as any).__MEUI_COOKIES_DEBUG__) {
    // eslint-disable-next-line no-console
    console.log(`[MEUI Cookies] ${message}`, ...args)
  }
}

/**
 * Parse cookie string
 */
export function parseCookie(name: string): string | null {
  if (typeof document === 'undefined') return null

  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)

  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null
  }

  return null
}

/**
 * Set cookie
 */
export function setCookie(name: string, value: string, days: number, domain?: string): void {
  if (typeof document === 'undefined') return

  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)

  const domainStr = domain ? `; domain=${domain}` : ''
  document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/${domainStr}; SameSite=Lax`
}

/**
 * Delete cookie
 */
export function deleteCookie(name: string, domain?: string): void {
  if (typeof document === 'undefined') return

  const domainStr = domain ? `; domain=${domain}` : ''
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${domainStr}`
}
